// @src/utils/iconMap.ts
import {
	IconAvatar,
	IconTree,
	IconList,
	IconForm,
	IconButton,
	IconToken,
	IconConfig,
	IconChangelog,
	IconPincode,
	IconNotification,
	IconTag
} from '@douyinfe/semi-icons-lab'
import { IconTickCircle, IconHelpCircle } from '@douyinfe/semi-icons'

export const IconMap: Record<string, React.ComponentType> = {
	IconAvatar,
	IconTree,
	IconList,
	IconForm,
	IconButton,
	IconToken,
	IconTickCircle,
	IconNotification,
	IconConfig,
	IconChangelog,
	IconHelpCircle,
	IconPincode,
	IconTag
}
